import React, { useEffect, useState, Fragment } from "react"
import { useHistory } from "react-router-dom"
import { useSelector, useDispatch } from 'react-redux'
import { selectThemeColors, getContrastTextColor, isLightColor, formatDate } from '@utils'
import makeAnimated from 'react-select/animated'
import Select from 'react-select'
import Flatpickr from 'react-flatpickr'
import '@styles/react/libs/flatpickr/flatpickr.scss'
import {
    X,
    Video,
    ArrowRight,
    File,
    Trash,
    Eye,
    Check,
    Droplet,
    RefreshCw,
    Tag,
    Clock,
    Calendar
} from 'react-feather'
import PDF from "@src/assets/images/icons/pdf1.png"
import {
    FormGroup,
    Row,
    Col,
    Input,
    Form,
    Button,
    CustomInput,
    Alert,
    Card,
    CardBody,
    Spinner,
    Table
} from 'reactstrap'
import {
    getBrandGoalsSelectValues,
    getBrandCompanySelectValues,
    getHearAboutUsOptions
} from '@store/actions/auth'
import { NULL } from '@store/actionTypes'
import {
    getCountries,
    nullResponse,
    removeMediaFromProfile
} from '@store/actions/brandsDashboard'
import * as yup from "yup"
import { useFormik } from "formik"
import {
    getRegions,
    getStates,
    getMultipleCities
} from "@src/views/apps/opportunitiesBrands/store/actions/index"
import Avatar from "@components/avatar"
import blankImage from "@src/assets/images/avatars/avatar-blank.png"
import classnames from "classnames"
import {
    viewProfile,
    saveProfile,
    saveProfileReset
} from "@src/redux/actions/BrandActions"
import Uploader from "@src/views/components/Uploader"
import ImageViewer from "@src/views/components/ImageViewer"
import PdfViewer from "@src/views/components/PdfViewer"
import VideoPlayer from "@src/views/components/VideoPlayer"
import draftToHtml from "draftjs-to-html"
import htmlToDraft from 'html-to-draftjs'
import { ContentState, convertToRaw, EditorState } from "draft-js"
import { Editor } from 'react-draft-wysiwyg'
import '@styles/react/libs/editor/editor.scss'
import '@styles/base/plugins/forms/form-quill-editor.scss'
import CustomLabel from '@src/views/components/CustomLabel'
import { confirmAlert, successAlert, errorAlert } from '@src/views/components/CustomAlerts'

const EditBrandProfile = () => {
    const history = useHistory()

    let userData = {}
    try {
        userData = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_USERDATA}`)) || {}
    } catch (e) {
        userData = {}
    }

    const COMPANY_LOGO_FORMATS = ["image/png", "image/jpeg", "image/jpg"]

    const urlRegex = /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/i

    const onlyCharRegex = /^[aA-zZ\s]+$/

    const animatedComponents = makeAnimated()

    const [companyLogoViewLink, setCompanyLogoViewLink] = useState("")
    const [profileMedia, setProfileMedia] = useState([])
    const [showUploader, setShowUploader] = useState(false)
    const [attachments, setAttachments] = useState([])
    const [imageViewer, setImageViewer] = useState({ show: false, src: '' })
    const [pdfViewer, setPdfViewer] = useState({ show: false, url: '', filename: '' })
    const [videoPlayer, setVideoPlayer] = useState({ show: false, url: '', filename: '' })

    const [rdDiscountOffer, setRdDiscountOffer] = useState('')
    const [rdDiscountScope, setRdDiscountScope] = useState('')
    const [rdDiscountExpiryDate, setRdDiscountExpiryDate] = useState(null)
    const [rdDiscountNoExpiry, setRdDiscountNoExpiry] = useState(false)

    const [clientDiscountOffer, setClientDiscountOffer] = useState('')
    const [clientDiscountScope, setClientDiscountScope] = useState('')
    const [clientDiscountExpiryDate, setClientDiscountExpiryDate] = useState(null)
    const [clientDiscountNoExpiry, setClientDiscountNoExpiry] = useState(false)

    const [discountCustomNote, setDiscountCustomNote] = useState('')

    const parseDiscountDetails = (raw) => {
        if (!raw || typeof raw !== 'string') {
            return {
                rd: { offer: '', scope: '', expiryDate: null, noExpiry: false },
                client: { offer: '', scope: '', expiryDate: null, noExpiry: false },
                customNote: ''
            }
        }

        const parseSection = (str) => {
            const trimmed = str.trim()
            if (!trimmed) return { offer: '', scope: '', expiryDate: null, noExpiry: false, note: '' }
            let offer = '', scope = '', expiryDate = null, noExpiry = false
            const notes = []
            const lowerAll = trimmed.toLowerCase()
            if (lowerAll.includes('ongoing') || lowerAll.includes('no expiration') || lowerAll.includes('no expiry') || lowerAll.includes('never expires')) {
                noExpiry = true
            }
            let tokens = []
            if (trimmed.includes(' · ')) tokens = trimmed.split(' · ')
            else if (trimmed.includes(' • ')) tokens = trimmed.split(' • ')
            else if (trimmed.includes(';')) tokens = trimmed.split(';')
            else tokens = [trimmed]

            tokens = tokens.map(t => t.trim()).filter(Boolean)
            tokens.forEach((token, index) => {
                const tokenLower = token.toLowerCase()
                if (tokenLower.includes('ongoing') || tokenLower.includes('no expiration') || tokenLower.includes('no expiry') || tokenLower.includes('never expires')) {
                    noExpiry = true
                    return
                }
                const validMatch = token.match(/(?:valid\s*(?:through|until|to|thru)?|expires(?:\s*on)?|expiry:?|exp:?)\s*(.+)/i)
                if (validMatch && validMatch[1]) {
                    const dateCandidate = new Date(validMatch[1].trim())
                    if (!isNaN(dateCandidate.getTime())) {
                        expiryDate = dateCandidate
                        noExpiry = false
                        return
                    }
                }
                if (token.length >= 6 && /\d{4}/.test(token)) {
                    const directDate = new Date(token)
                    if (!isNaN(directDate.getTime())) {
                        expiryDate = directDate
                        noExpiry = false
                        return
                    }
                }
                if (!offer && (
                    /\b\d+%\s*(?:off|discount)?/i.test(token) ||
                    /\$\d+\s*(?:off|discount)?/i.test(token) ||
                    /free\s*shipping/i.test(token) ||
                    /bogo/i.test(token) ||
                    /buy\s*\d+\s*get/i.test(token)
                )) {
                    offer = token
                    return
                }
                if (!scope && (
                    /sitewide/i.test(token) ||
                    /any\s*order/i.test(token) ||
                    /no\s*minimum/i.test(token) ||
                    /orders?\s*over/i.test(token) ||
                    /first\s*purchase/i.test(token) ||
                    /first\s*order/i.test(token) ||
                    /all\s*products/i.test(token) ||
                    /subscription/i.test(token) ||
                    /min(?:\.|\s*spend)?/i.test(token)
                )) {
                    scope = token
                    return
                }
                if (!offer && index === 0) {
                    offer = token
                    return
                }
                notes.push(token)
            })
            return { offer, scope, expiryDate, noExpiry, note: notes.join(' · ') }
        }

        if (raw.includes('|')) {
            const [firstPart, secondPart] = raw.split('|').map(s => s.trim())
            let rdPart = firstPart, clPart = secondPart
            if (secondPart.toLowerCase().startsWith('rd:') || firstPart.toLowerCase().startsWith('client:')) {
                rdPart = secondPart
                clPart = firstPart
            }
            rdPart = rdPart.replace(/^(?:rd|rd exclusive):?\s*/i, '')
            clPart = clPart.replace(/^(?:client):?\s*/i, '')
            const parsedRd = parseSection(rdPart)
            const parsedCl = parseSection(clPart)
            return {
                rd: parsedRd,
                client: parsedCl,
                customNote: [parsedRd.note, parsedCl.note].filter(Boolean).join(' · ')
            }
        }

        let cleanRaw = raw
        const isExplicitRd = /^(?:rd|rd exclusive):?\s*/i.test(cleanRaw)
        const isExplicitCl = /^(?:client):?\s*/i.test(cleanRaw)
        cleanRaw = cleanRaw.replace(/^(?:rd|rd exclusive|client):?\s*/i, '')
        const parsed = parseSection(cleanRaw)

        if (isExplicitCl) {
            return {
                rd: { offer: '', scope: '', expiryDate: null, noExpiry: false },
                client: parsed,
                customNote: parsed.note
            }
        }

        return {
            rd: parsed,
            client: { offer: '', scope: '', expiryDate: null, noExpiry: false },
            customNote: parsed.note
        }
    }

    const recompileAllDiscountDetails = (rdOffer, rdScope, rdExpiry, rdNoExpiry, clOffer, clScope, clExpiry, clNoExpiry, note) => {
        const formatSection = (offer, scope, expiry, noExpiry) => {
            const parts = []
            if (offer && offer.trim()) parts.push(offer.trim())
            if (scope && scope.trim()) parts.push(scope.trim())
            if (noExpiry) {
                parts.push('Ongoing offer')
            } else if (expiry) {
                try {
                    const d = expiry instanceof Date ? expiry : new Date(expiry)
                    if (!isNaN(d.getTime())) {
                        const formatted = formatDate(d, { month: 'short', day: 'numeric', year: 'numeric' })
                        parts.push(`Valid through ${formatted}`)
                    }
                } catch (e) {}
            }
            return parts.join(' · ')
        }

        const rdText = formatSection(rdOffer, rdScope, rdExpiry, rdNoExpiry)
        const clText = formatSection(clOffer, clScope, clExpiry, clNoExpiry)
        const hasRd = Boolean(updateProfileForm.values.discountCode?.trim() || rdText)
        const hasCl = Boolean(updateProfileForm.values.clientDiscountCode?.trim() || clText)

        let compiled = ''
        if (hasRd && hasCl && rdText && clText) {
            compiled = `RD: ${rdText} | Client: ${clText}`
        } else if (rdText) {
            compiled = hasCl ? `RD: ${rdText}` : rdText
        } else if (clText) {
            compiled = hasRd ? `Client: ${clText}` : clText
        }

        if (note && note.trim()) {
            compiled = compiled ? `${compiled} · ${note.trim()}` : note.trim()
        }

        updateProfileForm.setFieldValue('discountDetails', compiled)
    }

    const handleRdOfferChange = (val) => {
        setRdDiscountOffer(val)
        recompileAllDiscountDetails(val, rdDiscountScope, rdDiscountExpiryDate, rdDiscountNoExpiry, clientDiscountOffer, clientDiscountScope, clientDiscountExpiryDate, clientDiscountNoExpiry, discountCustomNote)
    }

    const handleRdScopeChange = (val) => {
        setRdDiscountScope(val)
        recompileAllDiscountDetails(rdDiscountOffer, val, rdDiscountExpiryDate, rdDiscountNoExpiry, clientDiscountOffer, clientDiscountScope, clientDiscountExpiryDate, clientDiscountNoExpiry, discountCustomNote)
    }

    const handleRdDateChange = (date) => {
        setRdDiscountExpiryDate(date)
        setRdDiscountNoExpiry(false)
        recompileAllDiscountDetails(rdDiscountOffer, rdDiscountScope, date, false, clientDiscountOffer, clientDiscountScope, clientDiscountExpiryDate, clientDiscountNoExpiry, discountCustomNote)
    }

    const handleRdNoExpiryChange = (checked) => {
        setRdDiscountNoExpiry(checked)
        if (checked) {
            setRdDiscountExpiryDate(null)
        }
        recompileAllDiscountDetails(rdDiscountOffer, rdDiscountScope, checked ? null : rdDiscountExpiryDate, checked, clientDiscountOffer, clientDiscountScope, clientDiscountExpiryDate, clientDiscountNoExpiry, discountCustomNote)
    }

    const handleClientOfferChange = (val) => {
        setClientDiscountOffer(val)
        recompileAllDiscountDetails(rdDiscountOffer, rdDiscountScope, rdDiscountExpiryDate, rdDiscountNoExpiry, val, clientDiscountScope, clientDiscountExpiryDate, clientDiscountNoExpiry, discountCustomNote)
    }

    const handleClientScopeChange = (val) => {
        setClientDiscountScope(val)
        recompileAllDiscountDetails(rdDiscountOffer, rdDiscountScope, rdDiscountExpiryDate, rdDiscountNoExpiry, clientDiscountOffer, val, clientDiscountExpiryDate, clientDiscountNoExpiry, discountCustomNote)
    }

    const handleClientDateChange = (date) => {
        setClientDiscountExpiryDate(date)
        setClientDiscountNoExpiry(false)
        recompileAllDiscountDetails(rdDiscountOffer, rdDiscountScope, rdDiscountExpiryDate, rdDiscountNoExpiry, clientDiscountOffer, clientDiscountScope, date, false, discountCustomNote)
    }

    const handleClientNoExpiryChange = (checked) => {
        setClientDiscountNoExpiry(checked)
        if (checked) {
            setClientDiscountExpiryDate(null)
        }
        recompileAllDiscountDetails(rdDiscountOffer, rdDiscountScope, rdDiscountExpiryDate, rdDiscountNoExpiry, clientDiscountOffer, clientDiscountScope, checked ? null : clientDiscountExpiryDate, checked, discountCustomNote)
    }

    const handleNoteChange = (val) => {
        setDiscountCustomNote(val)
        recompileAllDiscountDetails(rdDiscountOffer, rdDiscountScope, rdDiscountExpiryDate, rdDiscountNoExpiry, clientDiscountOffer, clientDiscountScope, clientDiscountExpiryDate, clientDiscountNoExpiry, val)
    }

    const dispatch = useDispatch()

    const {
        countries,
        removeMediaAtProfile
    } = useSelector((store) => store.brandsDashboardSlice)

    const {
        hearAboutOptions,
        brandCompanySelectValues,
        brandGoalsSelectValues
    } = useSelector(state => state.auth)


    const {
        viewProfileLoading,
        viewProfileData,

        saveProfileLoading,
        saveProfileData,
        saveProfileError
    } = useSelector(state => state.brandReducer)

    const {
        regions,
        states,
        cities
    } = useSelector((store) => store.brandsOppoprunities)

    const [aboutCompanyEditorState, setAboutCompanyEditorState] = useState(() => EditorState.createEmpty())

    const updateProfileForm = useFormik({
        initialValues: {
            email: '',
            firstAndLastName: '',
            companyName: '',
            personTitle: '',
            phoneNumber: '',
            companyLogoFile: '',
            brandColor: '#56B6FF',
            brandSecondaryColor: '',
            aboutCompany: '',
            website: '',
            shopWebsite: '',
            discountCode: '',
            clientDiscountCode: '',
            discountDetails: '',
            facebook: '',
            instagram: '',
            twitter: '',
            pinterest: '',
            linkedin: '',
            tiktok: '',
            companyValues: [],
            specialDiet: [],
            foodCategory: [],
            goals: '',
            personalAttributes: [],
            industry: [],
            speciality: [],
            country: null,
            region: null,
            state: [],
            city: [],
            hearAboutUs: null,
            hereAboutOtherInput: ''
        },
        validationSchema: yup.object().shape({
            email: yup.string().email('This field is required.').required("This field is required."),
            firstAndLastName: yup.string().trim().required("This field is required.").matches(onlyCharRegex, "Only alphabets are allowed."),
            companyName: yup.string().trim().required("This field is required."),
            personTitle: yup.string().trim().required("This field is required."),
            phoneNumber: yup.string().trim().required("This field is required."),
            companyLogoFile: yup.mixed()
                .test(
                    "fileFormat",
                    "File is empty or invalid.",
                    value => !value || (value && COMPANY_LOGO_FORMATS.includes(value.type))
                ),
            website: yup.string().test('urlMatch', 'Invalid URL.', (value) => {
                if (value && value.length > 0) {
                    return urlRegex.test(value)
                }
                return true
            }),
            shopWebsite: yup.string().test('urlMatch', 'Invalid URL.', (value) => {
                if (value && value.length > 0) {
                    return urlRegex.test(value)
                }
                return true
            }),
            facebook: yup.string().test('urlMatch', 'Invalid URL.', (value) => {
                if (value && value.length > 0) {
                    return urlRegex.test(value)
                }
                return true
            }),
            instagram: yup.string().test('urlMatch', 'Invalid URL.', (value) => {
                if (value && value.length > 0) {
                    return urlRegex.test(value)
                }
                return true
            }),
            twitter: yup.string().test('urlMatch', 'Invalid URL.', (value) => {
                if (value && value.length > 0) {
                    return urlRegex.test(value)
                }
                return true
            }),
            pinterest: yup.string().test('urlMatch', 'Invalid URL.', (value) => {
                if (value && value.length > 0) {
                    return urlRegex.test(value)
                }
                return true
            }),
            linkedin: yup.string().test('urlMatch', 'Invalid URL.', (value) => {
                if (value && value.length > 0) {
                    return urlRegex.test(value)
                }
                return true
            }),
            tiktok: yup.string().test('urlMatch', 'Invalid URL.', (value) => {
                if (value && value.length > 0) {
                    return urlRegex.test(value)
                }
                return true
            }),
            brandColor: yup.string().test('hexMatch', 'Invalid HEX format (e.g. #56B6FF)', (value) => {
                if (value && value.trim().length > 0) {
                    return /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(value.trim())
                }
                return true
            }),
            brandSecondaryColor: yup.string().test('hexMatch', 'Invalid HEX format (e.g. #163B2A)', (value) => {
                if (value && value.trim().length > 0) {
                    return /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(value.trim())
                }
                return true
            }),
            discountDetails: yup.string().max(1000, 'Max 1000 characters allowed.').test(
                'requiresCode',
                'Please provide an RD or Client coupon code before adding discount terms.',
                function (value) {
                    if (value && value.trim().length > 0) {
                        const { discountCode, clientDiscountCode } = this.parent
                        return Boolean(discountCode?.trim() || clientDiscountCode?.trim())
                    }
                    return true
                }
            ),
            goals: yup.string().trim().required("This field is required.")
        }),
        onSubmit: async (values) => {
            const formData = new FormData()
            const hasCodes = Boolean(values.discountCode?.trim() || values.clientDiscountCode?.trim())
            formData.append("email", values.email)
            formData.append("name", values.firstAndLastName)
            formData.append("brand_name", values.companyName)
            formData.append("person_title", values.personTitle)
            formData.append("phone_number", values.phoneNumber)
            if (values?.companyLogoFile) {
                formData.append("company_logo", values?.companyLogoFile)
            }
            formData.append("brand_color", values.brandColor || '#56B6FF')
            formData.append("brand_secondary_color", values.brandSecondaryColor || '')
            formData.append("about_company", values.aboutCompany)
            formData.append("website", values.website)
            formData.append("shop_website", values.shopWebsite || "")
            formData.append("discount_code", values.discountCode || "")
            formData.append("client_discount_code", values.clientDiscountCode || "")
            formData.append("discount_details", hasCodes ? (values.discountDetails || "") : "")
            formData.append("facebook_url", values.facebook)
            formData.append("instagram_url", values.instagram)
            formData.append("twitter_url", values.twitter)
            formData.append("pinterest_url", values.pinterest)
            formData.append("linkedin_url", values.linkedin)
            formData.append("tiktok_url", values.tiktok || "")
            if (values?.companyValues && Array.isArray(values.companyValues)) {
                values.companyValues.forEach(id => formData.append("values[]", id?.id || id))
            }
            if (values?.specialDiet && Array.isArray(values.specialDiet)) {
                values.specialDiet.forEach(id => formData.append("special_diet[]", id?.id || id))
            }
            if (values?.foodCategory && Array.isArray(values.foodCategory)) {
                values.foodCategory.forEach(id => formData.append("category[]", id?.id || id))
            }
            formData.append("goals", values.goals || "")
            if (values?.personalAttributes && Array.isArray(values.personalAttributes)) {
                values.personalAttributes.forEach(id => formData.append("personal_attributes[]", id?.id || id))
            }
            if (values?.industry && Array.isArray(values.industry)) {
                values.industry.forEach(id => formData.append("industry[]", id?.id || id))
            }
            if (values?.speciality && Array.isArray(values.speciality)) {
                values.speciality.forEach(id => formData.append("speciality[]", id?.id || id))
            }
            if (values?.country && values.country.id) {
                formData.append("country[]", values.country.id)
            }
            if (values?.region && values.region.id) {
                formData.append("region[]", values.region.id)
            }
            if (values?.state && Array.isArray(values.state)) {
                values.state.forEach(id => formData.append("state[]", id?.id || id))
            }
            if (values?.city && Array.isArray(values.city)) {
                values.city.forEach(id => formData.append("city[]", id?.id || id))
            }
            if (values?.hearAboutUs && values.hearAboutUs.id) {
                formData.append("here_about", values.hearAboutUs.id)
                formData.append("is_other_hear_about", values.hereAboutOtherInput || "")
            }
            if (attachments?.length > 0) {
                attachments.forEach(item => formData.append("media_documents[]", JSON.stringify(item)))
            }
            dispatch(saveProfile(formData))
        }
    })

    useEffect(() => {
        if (removeMediaAtProfile?.success) {
            dispatch(nullResponse(NULL.BRANDS_REMOVE_MEDIA_ON_PROFILE))
        }
    }, [removeMediaAtProfile])

    useEffect(() => {
        if (viewProfileData?.data) {
            const res = viewProfileData.data
            updateProfileForm.setFieldValue('email', res?.email || '')
            updateProfileForm.setFieldValue('firstAndLastName', res?.name || '')
            updateProfileForm.setFieldValue('companyName', res?.brand_name || '')
            updateProfileForm.setFieldValue('personTitle', res?.contact_title || '')
            updateProfileForm.setFieldValue('phoneNumber', res?.phone_number || '')
            updateProfileForm.setFieldValue('brandColor', res?.brand_color || '#56B6FF')
            updateProfileForm.setFieldValue('brandSecondaryColor', res?.brand_secondary_color || '')
            if (res?.about_company) {
                try {
                    const contentBlock = htmlToDraft(res.about_company)
                    if (contentBlock && contentBlock.contentBlocks) {
                        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks, contentBlock.entityMap)
                        setAboutCompanyEditorState(EditorState.createWithContent(contentState))
                    }
                } catch (e) {
                    setAboutCompanyEditorState(EditorState.createEmpty())
                }
            } else {
                setAboutCompanyEditorState(EditorState.createEmpty())
            }
            updateProfileForm.setFieldValue('aboutCompany', res?.about_company || '')
            setCompanyLogoViewLink(res?.company_logo || '')
            updateProfileForm.setFieldValue('website', res?.website || '')
            updateProfileForm.setFieldValue('shopWebsite', res?.shop_website || '')
            updateProfileForm.setFieldValue('discountCode', res?.discount_code || '')
            updateProfileForm.setFieldValue('clientDiscountCode', res?.client_discount_code || '')
            updateProfileForm.setFieldValue('discountDetails', res?.discount_details || '')
            if (res?.discount_details) {
                const parsed = parseDiscountDetails(res.discount_details)
                setRdDiscountOffer(parsed.rd?.offer || '')
                setRdDiscountScope(parsed.rd?.scope || '')
                setRdDiscountExpiryDate(parsed.rd?.expiryDate || null)
                setRdDiscountNoExpiry(parsed.rd?.noExpiry || false)

                setClientDiscountOffer(parsed.client?.offer || '')
                setClientDiscountScope(parsed.client?.scope || '')
                setClientDiscountExpiryDate(parsed.client?.expiryDate || null)
                setClientDiscountNoExpiry(parsed.client?.noExpiry || false)

                setDiscountCustomNote(parsed.customNote || '')
            } else {
                setRdDiscountOffer('')
                setRdDiscountScope('')
                setRdDiscountExpiryDate(null)
                setRdDiscountNoExpiry(false)

                setClientDiscountOffer('')
                setClientDiscountScope('')
                setClientDiscountExpiryDate(null)
                setClientDiscountNoExpiry(false)

                setDiscountCustomNote('')
            }
            updateProfileForm.setFieldValue('facebook', res?.facebook_url || '')
            updateProfileForm.setFieldValue('instagram', res?.instagram_url || '')
            updateProfileForm.setFieldValue('twitter', res?.twitter_url || '')
            updateProfileForm.setFieldValue('pinterest', res?.pinterest_url || '')
            updateProfileForm.setFieldValue('linkedin', res?.linkedin_url || '')
            updateProfileForm.setFieldValue('tiktok', res?.tiktok_url || '')
            updateProfileForm.setFieldValue('companyValues', res?.attributes?.values || [])
            updateProfileForm.setFieldValue('specialDiet', res?.attributes?.special_diet || [])
            updateProfileForm.setFieldValue('foodCategory', res?.attributes?.category || [])
            updateProfileForm.setFieldValue('goals', res?.goals || '')
            updateProfileForm.setFieldValue('personalAttributes', res?.interested_brands?.personal_attributes || [])
            updateProfileForm.setFieldValue('industry', res?.interested_brands?.industry || [])
            updateProfileForm.setFieldValue('speciality', res?.interested_brands?.speciality || [])
            updateProfileForm.setFieldValue('country', res?.location?.country || null)
            updateProfileForm.setFieldValue('region', res?.location?.region || null)
            updateProfileForm.setFieldValue('state', res?.location?.state || [])
            updateProfileForm.setFieldValue('city', res?.location?.city || [])
            if (res?.hear_about_us) {
                updateProfileForm.setFieldValue('hearAboutUs', res.hear_about_us)
            }
            updateProfileForm.setFieldValue('hereAboutOtherInput', res?.is_other_hear_about || '')
            if (res?.media?.length > 0) {
                setProfileMedia(res?.media.filter(x => x?.product_image !== null))
            }
            if (res?.location?.country?.id) {
                // dispatch the state functio as region is hidden
                dispatch(getStates(res?.location?.country?.id, true))
                // dispatch(getRegions(res?.location?.country?.id))
            }
            if (res?.location?.region?.id) {
                // dispatch(getStates(res?.location?.region?.id))
            }
            if (res?.location?.state?.length > 0) {
                const formData = new FormData()
                res?.location?.state?.map((item) => {
                    formData.append('state_id[]', item?.id)
                })
                dispatch(getMultipleCities(formData))
            }
        }
    }, [viewProfileData])

    useEffect(() => {
        if (saveProfileError?.response?.status) {
            const errorData = saveProfileError?.response?.data
            const errorHTML = ['<ul class="list-group">']
            if (errorData && typeof errorData === 'object') {
                Object.keys(errorData).forEach((key) => {
                    const err = errorData[key]
                    if (Array.isArray(err) && err.length > 0) {
                        errorHTML.push(`<li class="list-group-item font-small-3 text-danger">${err[0]}</li>`)
                    } else if (typeof err === 'string') {
                        errorHTML.push(`<li class="list-group-item font-small-3 text-danger">${err}</li>`)
                    }
                })
            } else {
                errorHTML.push('<li class="list-group-item font-small-3 text-danger">Something went wrong while saving profile.</li>')
            }
            errorHTML.push('</ul>')
            errorAlert(errorHTML.join(''))
            updateProfileForm.setFieldValue('captchaToken', '')
            dispatch(saveProfileReset())
        }
        if (saveProfileData?.success) {
            userData.name = saveProfileData?.data.name
            userData.brand_name = saveProfileData?.data.company_name
            userData.logo = saveProfileData?.data.company_logo
            localStorage.setItem(`${process.env.REACT_APP_USERDATA}`, JSON.stringify(userData))
            successAlert('<p class="font-small-3 mt-2 mb-0 font-weight-bold">Your profile updated successfully.</p> <p class="font-small-3">Redirecting to your profile...</p>', false)
            dispatch(saveProfileReset())
            setTimeout(() => {
                history.push('/dashboard/brands/profile')
            }, 1500)
        }
    }, [saveProfileData, saveProfileError])

    useEffect(() => {
        dispatch(getCountries())
        dispatch(getBrandCompanySelectValues())
        dispatch(getBrandGoalsSelectValues())
        dispatch(getHearAboutUsOptions())
        dispatch(viewProfile())
    }, [])

    const getRegionsById = (e) => {
        dispatch(getRegions(e?.id))
    }

    const getStatesById = (e, is_country = false) => {
        dispatch(getStates(e?.id, is_country))
    }

    const getCitiesById = (e) => {
        const formData = new FormData()
        e.map((item) => {
            formData.append('state_id[]', item?.id)
        })
        dispatch(getMultipleCities(formData))
    }

    const handleRemoveMedia = async (file) => {
        const isConfirmed = await confirmAlert('Confirm!', 'Do you really want to delete?')
        if (isConfirmed && file?.id) {
            setProfileMedia(profileMedia?.filter(x => x.id !== file.id))
            dispatch(removeMediaFromProfile(file?.id))
        }
    }

    const handleCompanyLogo = (event) => {
        if (event.target.files && event.target.files[0]) {
            setCompanyLogoViewLink(URL.createObjectURL(event.target.files[0]))
        }
    }

    const deleteUploads = async (index) => {
        const isConfirmed = await confirmAlert('Confirm!', 'Do you really want to delete?')
        if (isConfirmed) {
            setAttachments(prevAttachments => {
                return prevAttachments.filter((_, i) => i !== index)
            })
        }
    }

    const onSuccessUploads = (data) => {
        const itemWithCategory = {
            ...data,
            resource_category: 'education'
        }
        setAttachments(prevAttachments => [...prevAttachments, itemWithCategory])
        successAlert(`<p>File uploaded successfully</p>`)
        setShowUploader(false)
    }

    const onErrorUploads = (error) => {
        errorAlert(`<p>${JSON.stringify(error)}</p>`)
        setShowUploader(false)
    }

    return (
        <Fragment>
            <h3>Edit Your Profile</h3>
            <Card>
                <CardBody>
                    {viewProfileLoading ? (
                        <Alert className="mx-2 mt-2" color='primary'>
                            <div className='alert-body text-center'>
                                <Spinner style={{ width: '18px', height: '18px' }} /> Please wait...
                            </div>
                        </Alert>
                    ) : (
                        <Form onSubmit={updateProfileForm.handleSubmit}>
                            <Row>
                                <FormGroup tag={Col} md='12'>
                                    <div className="item-img text-center mx-auto">
                                        <Avatar img={companyLogoViewLink || blankImage} imgHeight="150" imgWidth="150" className="avatar-img-fit-contain" />
                                    </div>
                                </FormGroup>
                                <FormGroup tag={Col} md='12'>
                                    <hr />
                                </FormGroup>
                            </Row>
                            <Row>
                                <FormGroup tag={Col} md='4'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="email"
                                        title="Email"
                                    />
                                    <Input
                                        type="email"
                                        name="email"
                                        id="email"
                                        value={updateProfileForm.values.email}
                                        onBlur={updateProfileForm.handleBlur}
                                        onChange={updateProfileForm.handleChange}
                                        className={classnames({ 'is-invalid': updateProfileForm.touched.email && updateProfileForm.errors.email })}
                                        placeholder="Email"
                                        disabled={viewProfileLoading || saveProfileLoading}
                                    />
                                    <div className="validation-err">{updateProfileForm.touched.email && updateProfileForm.errors.email}</div>
                                </FormGroup>
                                <FormGroup tag={Col} md='4'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="firstAndLastName"
                                        title="First and Last Name"
                                    />
                                    <Input type="text"
                                        name="firstAndLastName"
                                        id="firstAndLastName"
                                        value={updateProfileForm.values.firstAndLastName}
                                        onBlur={updateProfileForm.handleBlur}
                                        onChange={updateProfileForm.handleChange}
                                        className={classnames({ 'is-invalid': updateProfileForm.touched.firstAndLastName && updateProfileForm.errors.firstAndLastName })}
                                        placeholder="First and Last Name"
                                        disabled={viewProfileLoading || saveProfileLoading}
                                    />
                                    <div className="validation-err">{updateProfileForm.touched.firstAndLastName && updateProfileForm.errors.firstAndLastName}</div>
                                </FormGroup>
                                <FormGroup tag={Col} md='4'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="companyName"
                                        title="Company Name"
                                    />
                                    <Input type="text"
                                        name="companyName"
                                        id="companyName"
                                        value={updateProfileForm.values.companyName}
                                        onBlur={updateProfileForm.handleBlur}
                                        onChange={updateProfileForm.handleChange}
                                        className={classnames({ 'is-invalid': updateProfileForm.touched.companyName && updateProfileForm.errors.companyName })}
                                        placeholder="Company Name"
                                        disabled={viewProfileLoading || saveProfileLoading}
                                    />
                                    <div className="validation-err">{updateProfileForm.touched.companyName && updateProfileForm.errors.companyName}</div>
                                </FormGroup>
                                <FormGroup tag={Col} md='4'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="personTitle"
                                        title="Your Title"
                                    />
                                    <Input type="text"
                                        name="personTitle"
                                        id="personTitle"
                                        value={updateProfileForm.values.personTitle}
                                        onBlur={updateProfileForm.handleBlur}
                                        onChange={updateProfileForm.handleChange}
                                        className={classnames({ 'is-invalid': updateProfileForm.touched.personTitle && updateProfileForm.errors.personTitle })}
                                        placeholder="Your Title"
                                        disabled={viewProfileLoading || saveProfileLoading}
                                    />
                                    <div className="validation-err">{updateProfileForm.touched.personTitle && updateProfileForm.errors.personTitle}</div>
                                </FormGroup>
                                <FormGroup tag={Col} md='4'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="phoneNumber"
                                        title="Phone Number"
                                    />
                                    <Input type="text"
                                        name="phoneNumber"
                                        id="phoneNumber"
                                        value={updateProfileForm.values.phoneNumber}
                                        onBlur={updateProfileForm.handleBlur}
                                        onChange={updateProfileForm.handleChange}
                                        className={classnames({ 'is-invalid': updateProfileForm.touched.phoneNumber && updateProfileForm.errors.phoneNumber })}
                                        placeholder="Phone Number"
                                        disabled={viewProfileLoading || saveProfileLoading}
                                    />
                                    <div className="validation-err">{updateProfileForm.touched.phoneNumber && updateProfileForm.errors.phoneNumber}</div>
                                </FormGroup>
                                <FormGroup tag={Col} md='4'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="companyLogoFile"
                                        title="Company Logo"
                                        isRequired={false}
                                        msg="Only PNG, JPEG, JPG"
                                    />
                                    <CustomInput type="file"
                                        name="companyLogoFile"
                                        id="companyLogoFile"
                                        accept=".png, .jpg, .jpeg"
                                        onChange={(e) => {
                                            updateProfileForm.setFieldValue('companyLogoFile', e.target.files[0])
                                            handleCompanyLogo(e)
                                        }}
                                        onBlur={updateProfileForm.handleBlur}
                                        className={classnames({ 'is-invalid': updateProfileForm.touched.companyLogoFile && updateProfileForm.errors.companyLogoFile })}
                                        disabled={viewProfileLoading || saveProfileLoading}
                                    />
                                    <div className="validation-err">{updateProfileForm.touched.companyLogoFile && updateProfileForm.errors.companyLogoFile}</div>
                                </FormGroup>
                                <FormGroup tag={Col} md='12'>
                                    {(() => {
                                        const primaryVal = updateProfileForm.values.brandColor || '#56B6FF'
                                        const secondaryVal = updateProfileForm.values.brandSecondaryColor || ''
                                        const isPrimaryLight = isLightColor(primaryVal)
                                        const isSecondaryLight = secondaryVal ? isLightColor(secondaryVal) : false
                                        const primaryTextColor = isPrimaryLight ? '#1e293b' : '#ffffff'
                                        const primaryTaglineColor = isPrimaryLight ? 'rgba(30, 41, 59, 0.75)' : 'rgba(255, 255, 255, 0.85)'
                                        const primaryEyebrowColor = isPrimaryLight ? '#64748b' : 'rgba(255, 255, 255, 0.75)'
                                        const secondaryTextColor = secondaryVal ? getContrastTextColor(secondaryVal) : (isPrimaryLight ? '#1e293b' : '#ffffff')
                                        const pillBackground = secondaryVal || (isPrimaryLight ? 'rgba(0, 0, 0, 0.07)' : 'rgba(255, 255, 255, 0.16)')
                                        const pillBorder = secondaryVal ? (isSecondaryLight ? '1px solid rgba(0, 0, 0, 0.15)' : 'none') : (isPrimaryLight ? '1px solid rgba(0, 0, 0, 0.12)' : '1px solid rgba(255, 255, 255, 0.18)')
                                        const pillBackdropFilter = !secondaryVal ? 'blur(6px)' : 'none'
                                        const shopBtnBackground = secondaryVal || (isPrimaryLight ? 'rgba(0, 0, 0, 0.08)' : 'rgba(0, 0, 0, 0.22)')
                                        const shopBtnTextColor = secondaryVal ? getContrastTextColor(secondaryVal) : (isPrimaryLight ? '#1e293b' : '#ffffff')
                                        const shopBtnBorder = secondaryVal ? (isSecondaryLight ? '1px solid rgba(0, 0, 0, 0.15)' : 'none') : (isPrimaryLight ? '1px solid rgba(0, 0, 0, 0.16)' : '1px solid rgba(255, 255, 255, 0.25)')
                                        const shopBtnBackdropFilter = !secondaryVal ? 'blur(4px)' : 'none'

                                        return (
                                            <div className="card shadow-sm border mb-0" style={{ borderRadius: '12px', overflow: 'hidden' }}>
                                                {/* Card Header */}
                                                <div
                                                    className="p-1 p-sm-2 d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between"
                                                    style={{
                                                        backgroundColor: '#f8fafc',
                                                        borderBottom: '1px solid #e2e8f0',
                                                        gap: '12px'
                                                    }}
                                                >
                                                    <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                                                        <div
                                                            style={{
                                                                width: '36px',
                                                                height: '36px',
                                                                borderRadius: '8px',
                                                                background: secondaryVal
                                                                    ? `linear-gradient(135deg, ${primaryVal} 50%, ${secondaryVal} 50%)`
                                                                    : primaryVal,
                                                                color: isPrimaryLight ? '#1e293b' : '#ffffff',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                border: isPrimaryLight || isSecondaryLight ? '1px solid #cbd5e1' : 'none',
                                                                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                                                transition: 'background 0.25s ease',
                                                                flexShrink: 0
                                                            }}
                                                        >
                                                            <Droplet size={18} />
                                                        </div>
                                                        <div>
                                                            <h6 className="mb-0 font-weight-bolder" style={{ color: '#163b2a', fontSize: '14.5px' }}>
                                                                Brand Theme & Accent Colors
                                                            </h6>
                                                            <small className="text-muted d-block" style={{ fontSize: '11.5px', lineHeight: '1.3' }}>
                                                                Configure primary theme and secondary accent colors with automatic smart contrast
                                                            </small>
                                                        </div>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-secondary d-inline-flex align-items-center align-self-stretch align-self-sm-auto justify-content-center"
                                                        style={{ borderRadius: '6px', fontSize: '11.5px', padding: '5px 12px', flexShrink: 0 }}
                                                        onClick={() => {
                                                            updateProfileForm.setFieldValue('brandColor', '#56B6FF')
                                                            updateProfileForm.setFieldValue('brandSecondaryColor', '')
                                                        }}
                                                        title="Reset to default project theme colors"
                                                    >
                                                        <RefreshCw size={12} className="mr-50" /> Reset Defaults
                                                    </button>
                                                </div>

                                                {/* Card Body */}
                                                <div className="p-1 p-sm-2" style={{ backgroundColor: '#ffffff' }}>
                                                    <Row>
                                                        {/* Left Column: Primary & Secondary Color Selectors */}
                                                        <Col lg='6' className="mb-2 mb-lg-0 pr-lg-3">
                                                            {/* Primary Color Section */}
                                                            <div className="mb-2 pb-2 border-bottom">
                                                                <div className="d-flex align-items-center justify-content-between mb-50">
                                                                    <label className="font-weight-bold mb-0" style={{ fontSize: '12.5px', color: '#1e293b', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
                                                                        Primary Theme Color
                                                                    </label>
                                                                    <small className="text-muted font-weight-bold" style={{ fontSize: '10.5px' }}>
                                                                        Hero Banner & Cards
                                                                    </small>
                                                                </div>

                                                                <div className="d-flex align-items-center mb-1" style={{ gap: '10px' }}>
                                                                    {/* Color Swatch Picker */}
                                                                    <div
                                                                        style={{
                                                                            width: '42px',
                                                                            height: '38px',
                                                                            borderRadius: '8px',
                                                                            backgroundColor: primaryVal,
                                                                            border: isPrimaryLight ? '2px solid #cbd5e1' : '2px solid #ffffff',
                                                                            boxShadow: '0 2px 6px rgba(0,0,0,0.15), 0 0 0 1px #cbd5e1',
                                                                            cursor: 'pointer',
                                                                            position: 'relative',
                                                                            overflow: 'hidden',
                                                                            flexShrink: 0
                                                                        }}
                                                                        title="Click to open color picker wheel"
                                                                    >
                                                                        <input
                                                                            type="color"
                                                                            id="brandColorPicker"
                                                                            name="brandColorPicker"
                                                                            value={primaryVal.startsWith('#') && primaryVal.length === 7 ? primaryVal : '#56B6FF'}
                                                                            onChange={(e) => updateProfileForm.setFieldValue('brandColor', e.target.value)}
                                                                            style={{
                                                                                opacity: 0,
                                                                                position: 'absolute',
                                                                                top: 0,
                                                                                left: 0,
                                                                                width: '100%',
                                                                                height: '100%',
                                                                                cursor: 'pointer'
                                                                            }}
                                                                        />
                                                                    </div>

                                                                    {/* Hex Text Input */}
                                                                    <div style={{ flex: '1 1 140px', maxWidth: '200px' }}>
                                                                        <Input
                                                                            type="text"
                                                                            name="brandColor"
                                                                            id="brandColor"
                                                                            value={updateProfileForm.values.brandColor || ''}
                                                                            placeholder="#56B6FF"
                                                                            onChange={updateProfileForm.handleChange}
                                                                            onBlur={(e) => {
                                                                                let val = (e.target.value || '').trim()
                                                                                if (val && !val.startsWith('#') && (val.length === 3 || val.length === 6)) {
                                                                                    val = `#${val}`
                                                                                    updateProfileForm.setFieldValue('brandColor', val.toUpperCase())
                                                                                }
                                                                                updateProfileForm.handleBlur(e)
                                                                            }}
                                                                            className={classnames({ 'is-invalid': updateProfileForm.touched.brandColor && updateProfileForm.errors.brandColor })}
                                                                            style={{
                                                                                fontFamily: 'SFMono-Regular, Menlo, Monaco, Consolas, monospace',
                                                                                fontWeight: 700,
                                                                                fontSize: '13px',
                                                                                letterSpacing: '0.8px',
                                                                                textTransform: 'uppercase',
                                                                                height: '38px',
                                                                                borderRadius: '8px'
                                                                            }}
                                                                            disabled={viewProfileLoading || saveProfileLoading}
                                                                        />
                                                                        {updateProfileForm.touched.brandColor && updateProfileForm.errors.brandColor && (
                                                                            <div className="validation-err text-danger mt-25" style={{ fontSize: '11px' }}>
                                                                                {updateProfileForm.errors.brandColor}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                                {/* Curated Primary Presets */}
                                                                <div className="d-flex align-items-center flex-wrap" style={{ gap: '6px' }}>
                                                                    {[
                                                                        { name: 'App Blue', color: '#56B6FF' },
                                                                        { name: 'Forest', color: '#163B2A' },
                                                                        { name: 'Navy', color: '#1C2D42' },
                                                                        { name: 'Emerald', color: '#0F4C3A' },
                                                                        { name: 'Terracotta', color: '#8C3B23' },
                                                                        { name: 'Violet', color: '#4A2E6D' },
                                                                        { name: 'Charcoal', color: '#2B2D30' },
                                                                        { name: 'White', color: '#FFFFFF' }
                                                                    ].map((preset) => {
                                                                        const isSelected = primaryVal.toLowerCase() === preset.color.toLowerCase()
                                                                        const presetIsLight = isLightColor(preset.color)
                                                                        return (
                                                                            <button
                                                                                key={`primary-${preset.color}`}
                                                                                type="button"
                                                                                onClick={() => updateProfileForm.setFieldValue('brandColor', preset.color)}
                                                                                className="btn btn-sm p-0 d-inline-flex align-items-center justify-content-center"
                                                                                style={{
                                                                                    width: '28px',
                                                                                    height: '28px',
                                                                                    borderRadius: '50%',
                                                                                    backgroundColor: preset.color,
                                                                                    border: presetIsLight ? '1.5px solid #cbd5e1' : '1.5px solid #e2e8f0',
                                                                                    boxShadow: isSelected ? `0 0 0 2px ${presetIsLight ? '#0f172a' : preset.color}, 0 2px 6px rgba(0,0,0,0.2)` : '0 1px 3px rgba(0,0,0,0.1)',
                                                                                    transform: isSelected ? 'scale(1.12)' : 'scale(1)',
                                                                                    transition: 'all 0.15s ease'
                                                                                }}
                                                                                title={`${preset.name} (${preset.color})`}
                                                                            >
                                                                                {isSelected && (
                                                                                    <Check
                                                                                        size={13}
                                                                                        color={presetIsLight ? '#0f172a' : '#ffffff'}
                                                                                        strokeWidth={3}
                                                                                    />
                                                                                )}
                                                                            </button>
                                                                        )
                                                                    })}
                                                                </div>
                                                            </div>

                                                            {/* Secondary Color Section */}
                                                            <div>
                                                                <div className="d-flex align-items-center justify-content-between mb-50">
                                                                    <label className="font-weight-bold mb-0" style={{ fontSize: '12.5px', color: '#1e293b', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
                                                                        Secondary Accent Color <small className="text-muted font-weight-normal">(Optional)</small>
                                                                    </label>
                                                                    <small className="text-muted font-weight-bold" style={{ fontSize: '10.5px' }}>
                                                                        Badges & Highlights
                                                                    </small>
                                                                </div>

                                                                <div className="d-flex align-items-center mb-1" style={{ gap: '10px' }}>
                                                                    {/* Color Swatch Picker */}
                                                                    <div
                                                                        style={{
                                                                            width: '42px',
                                                                            height: '38px',
                                                                            borderRadius: '8px',
                                                                            backgroundColor: secondaryVal || (isPrimaryLight ? 'rgba(0,0,0,0.08)' : 'rgba(255,255,255,0.25)'),
                                                                            border: isSecondaryLight || (!secondaryVal && isPrimaryLight) ? '2px solid #cbd5e1' : '2px solid #ffffff',
                                                                            boxShadow: '0 2px 6px rgba(0,0,0,0.15), 0 0 0 1px #cbd5e1',
                                                                            cursor: 'pointer',
                                                                            position: 'relative',
                                                                            overflow: 'hidden',
                                                                            flexShrink: 0
                                                                        }}
                                                                        title="Click to open secondary color picker"
                                                                    >
                                                                        <input
                                                                            type="color"
                                                                            id="brandSecondaryColorPicker"
                                                                            name="brandSecondaryColorPicker"
                                                                            value={secondaryVal.startsWith('#') && secondaryVal.length === 7 ? secondaryVal : '#163B2A'}
                                                                            onChange={(e) => updateProfileForm.setFieldValue('brandSecondaryColor', e.target.value)}
                                                                            style={{
                                                                                opacity: 0,
                                                                                position: 'absolute',
                                                                                top: 0,
                                                                                left: 0,
                                                                                width: '100%',
                                                                                height: '100%',
                                                                                cursor: 'pointer'
                                                                            }}
                                                                        />
                                                                    </div>

                                                                    {/* Hex Text Input */}
                                                                    <div style={{ flex: '1 1 140px', maxWidth: '200px' }}>
                                                                        <Input
                                                                            type="text"
                                                                            name="brandSecondaryColor"
                                                                            id="brandSecondaryColor"
                                                                            value={updateProfileForm.values.brandSecondaryColor || ''}
                                                                            placeholder="Transparent (Default)"
                                                                            onChange={updateProfileForm.handleChange}
                                                                            onBlur={(e) => {
                                                                                let val = (e.target.value || '').trim()
                                                                                if (val && !val.startsWith('#') && (val.length === 3 || val.length === 6)) {
                                                                                    val = `#${val}`
                                                                                    updateProfileForm.setFieldValue('brandSecondaryColor', val.toUpperCase())
                                                                                }
                                                                                updateProfileForm.handleBlur(e)
                                                                            }}
                                                                            className={classnames({ 'is-invalid': updateProfileForm.touched.brandSecondaryColor && updateProfileForm.errors.brandSecondaryColor })}
                                                                            style={{
                                                                                fontFamily: 'SFMono-Regular, Menlo, Monaco, Consolas, monospace',
                                                                                fontWeight: 700,
                                                                                fontSize: '13px',
                                                                                letterSpacing: '0.8px',
                                                                                textTransform: 'uppercase',
                                                                                height: '38px',
                                                                                borderRadius: '8px'
                                                                            }}
                                                                            disabled={viewProfileLoading || saveProfileLoading}
                                                                        />
                                                                        {updateProfileForm.touched.brandSecondaryColor && updateProfileForm.errors.brandSecondaryColor && (
                                                                            <div className="validation-err text-danger mt-25" style={{ fontSize: '11px' }}>
                                                                                {updateProfileForm.errors.brandSecondaryColor}
                                                                            </div>
                                                                        )}
                                                                    </div>

                                                                    {secondaryVal && (
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-sm btn-outline-secondary d-inline-flex align-items-center"
                                                                            style={{ fontSize: '11.5px', padding: '6px 10px', borderRadius: '7px', flexShrink: 0, height: '38px' }}
                                                                            onClick={() => updateProfileForm.setFieldValue('brandSecondaryColor', '')}
                                                                            title="Reset to Transparent Glass"
                                                                        >
                                                                            Clear
                                                                        </button>
                                                                    )}
                                                                </div>

                                                                {/* Curated Secondary Presets */}
                                                                <div className="d-flex align-items-center flex-wrap" style={{ gap: '6px' }}>
                                                                    {/* Transparent Glass Preset */}
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => updateProfileForm.setFieldValue('brandSecondaryColor', '')}
                                                                        className="btn btn-sm p-0 d-inline-flex align-items-center justify-content-center"
                                                                        style={{
                                                                            width: '28px',
                                                                            height: '28px',
                                                                            borderRadius: '50%',
                                                                            background: isPrimaryLight ? 'rgba(0,0,0,0.08)' : 'rgba(255,255,255,0.2)',
                                                                            backdropFilter: 'blur(4px)',
                                                                            border: !secondaryVal ? '2px solid #56B6FF' : (isPrimaryLight ? '1.5px dashed #94a3b8' : '1.5px dashed #cbd5e1'),
                                                                            boxShadow: !secondaryVal ? '0 0 0 2px #56B6FF, 0 2px 6px rgba(0,0,0,0.18)' : 'none',
                                                                            transform: !secondaryVal ? 'scale(1.12)' : 'scale(1)',
                                                                            transition: 'all 0.15s ease'
                                                                        }}
                                                                        title="Transparent Glass (Default)"
                                                                    >
                                                                        {!secondaryVal && (
                                                                            <Check
                                                                                size={13}
                                                                                color={isPrimaryLight ? '#1e293b' : '#ffffff'}
                                                                                strokeWidth={3}
                                                                            />
                                                                        )}
                                                                    </button>

                                                                    {[
                                                                        { name: 'Forest', color: '#163B2A' },
                                                                        { name: 'Mint Green', color: '#28C76F' },
                                                                        { name: 'Warm Amber', color: '#FF9F43' },
                                                                        { name: 'Coral Red', color: '#EA5455' },
                                                                        { name: 'Cyan Blue', color: '#00CFE8' },
                                                                        { name: 'Indigo', color: '#7367F0' },
                                                                        { name: 'Dark Slate', color: '#334155' },
                                                                        { name: 'White', color: '#FFFFFF' }
                                                                    ].map((preset) => {
                                                                        const isSelected = secondaryVal.toLowerCase() === preset.color.toLowerCase()
                                                                        const presetIsLight = isLightColor(preset.color)
                                                                        return (
                                                                            <button
                                                                                key={`secondary-${preset.color}`}
                                                                                type="button"
                                                                                onClick={() => updateProfileForm.setFieldValue('brandSecondaryColor', preset.color)}
                                                                                className="btn btn-sm p-0 d-inline-flex align-items-center justify-content-center"
                                                                                style={{
                                                                                    width: '28px',
                                                                                    height: '28px',
                                                                                    borderRadius: '50%',
                                                                                    backgroundColor: preset.color,
                                                                                    border: presetIsLight ? '1.5px solid #cbd5e1' : '1.5px solid #e2e8f0',
                                                                                    boxShadow: isSelected ? `0 0 0 2px ${presetIsLight ? '#0f172a' : preset.color}, 0 2px 6px rgba(0,0,0,0.2)` : '0 1px 3px rgba(0,0,0,0.1)',
                                                                                    transform: isSelected ? 'scale(1.12)' : 'scale(1)',
                                                                                    transition: 'all 0.15s ease'
                                                                                }}
                                                                                title={`${preset.name} (${preset.color})`}
                                                                            >
                                                                                {isSelected && (
                                                                                    <Check
                                                                                        size={13}
                                                                                        color={presetIsLight ? '#0f172a' : '#ffffff'}
                                                                                        strokeWidth={3}
                                                                                    />
                                                                                )}
                                                                            </button>
                                                                        )
                                                                    })}
                                                                </div>
                                                            </div>
                                                        </Col>

                                                        {/* Divider on mobile / tablet */}
                                                        <Col xs='12' className="d-lg-none">
                                                            <hr className="my-2" style={{ borderColor: '#e2e8f0' }} />
                                                        </Col>

                                                        {/* Right Column: Live Interactive Profile Preview */}
                                                        <Col lg='6' className="pl-lg-3">
                                                            <div className="d-flex align-items-center justify-content-between flex-wrap mb-50" style={{ gap: '6px' }}>
                                                                <label className="font-weight-bold mb-0" style={{ fontSize: '12.5px', color: '#1e293b', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
                                                                    Live Profile Preview
                                                                </label>
                                                                <span className="badge badge-light-success d-inline-flex align-items-center" style={{ fontSize: '10.5px', padding: '3px 8px', borderRadius: '9999px' }}>
                                                                    <span style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#28c76f', marginRight: '5px' }}></span>
                                                                    Smart Contrast Active
                                                                </span>
                                                            </div>

                                                            {/* Hero Banner Snapshot */}
                                                            <div
                                                                className="p-1 rounded shadow-sm position-relative overflow-hidden mb-1"
                                                                style={{
                                                                    backgroundColor: primaryVal,
                                                                    border: isPrimaryLight ? '1px solid #e2e8f0' : 'none',
                                                                    backgroundImage: isPrimaryLight
                                                                        ? 'linear-gradient(180deg, rgba(0,0,0,0.02) 0%, rgba(0,0,0,0.05) 100%)'
                                                                        : 'linear-gradient(180deg, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.02) 100%)',
                                                                    borderRadius: '10px',
                                                                    transition: 'background-color 0.25s ease'
                                                                }}
                                                            >
                                                                <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                                                                    <div
                                                                        style={{
                                                                            width: '44px',
                                                                            height: '44px',
                                                                            borderRadius: '50%',
                                                                            backgroundColor: '#ffffff',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            overflow: 'hidden',
                                                                            flexShrink: 0,
                                                                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                                                            border: '1px solid #f1f5f9'
                                                                        }}
                                                                    >
                                                                        {companyLogoViewLink ? (
                                                                            <img src={companyLogoViewLink} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                                                                        ) : (
                                                                            <span style={{ color: isPrimaryLight ? '#0f172a' : primaryVal, fontWeight: 800, fontSize: '16px' }}>
                                                                                {(updateProfileForm.values.companyName || 'B').charAt(0).toUpperCase()}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                    <div style={{ minWidth: 0, flex: 1 }}>
                                                                        <h6 className="font-weight-bolder mb-0 text-truncate" style={{ fontSize: '14.5px', color: primaryTextColor }}>
                                                                            {updateProfileForm.values.companyName || 'Your Brand Name'}
                                                                        </h6>
                                                                        <small className="d-block text-truncate" style={{ fontSize: '11px', color: primaryTaglineColor }}>
                                                                            {updateProfileForm.values.personTitle || 'Official Brand Profile'}
                                                                        </small>
                                                                    </div>
                                                                </div>

                                                                {/* Pill tags in preview showing Secondary Color & contrast */}
                                                                <div className="d-flex flex-wrap mt-75" style={{ gap: '5px' }}>
                                                                    <span
                                                                        style={{
                                                                            backgroundColor: pillBackground,
                                                                            color: secondaryTextColor,
                                                                            border: pillBorder,
                                                                            backdropFilter: pillBackdropFilter,
                                                                            WebkitBackdropFilter: pillBackdropFilter,
                                                                            padding: '2.5px 10px',
                                                                            borderRadius: '9999px',
                                                                            fontSize: '10.5px',
                                                                            fontWeight: 600,
                                                                            boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
                                                                            transition: 'all 0.25s ease'
                                                                        }}
                                                                    >
                                                                        Supplements
                                                                    </span>
                                                                    <span
                                                                        style={{
                                                                            backgroundColor: pillBackground,
                                                                            color: secondaryTextColor,
                                                                            border: pillBorder,
                                                                            backdropFilter: pillBackdropFilter,
                                                                            WebkitBackdropFilter: pillBackdropFilter,
                                                                            padding: '2.5px 10px',
                                                                            borderRadius: '9999px',
                                                                            fontSize: '10.5px',
                                                                            fontWeight: 600,
                                                                            boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
                                                                            transition: 'all 0.25s ease'
                                                                        }}
                                                                    >
                                                                        NSF Certified
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            {/* Mini Discount Card Snapshot */}
                                                            <div
                                                                className="p-1 rounded shadow-sm d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between"
                                                                style={{
                                                                    backgroundColor: primaryVal,
                                                                    border: isPrimaryLight ? '1px solid #e2e8f0' : 'none',
                                                                    borderRadius: '8px',
                                                                    transition: 'background-color 0.25s ease',
                                                                    gap: '8px'
                                                                }}
                                                            >
                                                                <div style={{ minWidth: 0, flex: 1 }}>
                                                                    <small className="text-uppercase font-weight-bold d-block" style={{ fontSize: '9.5px', letterSpacing: '0.4px', color: primaryEyebrowColor }}>
                                                                        Discount Promotion Banner
                                                                    </small>
                                                                    <span className="font-weight-bold text-truncate d-block" style={{ fontSize: '12px', color: primaryTextColor }}>
                                                                        RD Code: {updateProfileForm.values.discountCode || 'RDLINK20'}
                                                                    </span>
                                                                </div>
                                                                <span
                                                                    className="badge font-weight-bold align-self-start align-self-sm-auto"
                                                                    style={{
                                                                        backgroundColor: shopBtnBackground,
                                                                        color: shopBtnTextColor,
                                                                        border: shopBtnBorder,
                                                                        backdropFilter: shopBtnBackdropFilter,
                                                                        WebkitBackdropFilter: shopBtnBackdropFilter,
                                                                        fontSize: '10.5px',
                                                                        borderRadius: '6px',
                                                                        flexShrink: 0,
                                                                        padding: '5px 9px',
                                                                        transition: 'all 0.25s ease'
                                                                    }}
                                                                >
                                                                    Shop Website
                                                                </span>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        )
                                    })()}
                                </FormGroup>
                                <FormGroup tag={Col} md='12'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="aboutCompany"
                                        title="About Company"
                                        isRequired={false}
                                    />
                                    <Editor editorState={aboutCompanyEditorState}
                                        onEditorStateChange={(e) => {
                                            setAboutCompanyEditorState(e)
                                            const contentState = e.getCurrentContent()
                                            if (contentState.hasText()) {
                                                updateProfileForm.setFieldValue('aboutCompany', draftToHtml(convertToRaw(contentState)))
                                            } else {
                                                updateProfileForm.setFieldValue('aboutCompany', "")
                                            }
                                        }}
                                        toolbar={{
                                            options: ['inline', 'blockType', 'fontSize', 'list', 'colorPicker', 'link', 'remove', 'history'],
                                            inline: {
                                                options: ['bold', 'italic', 'underline']
                                            },
                                            list: {
                                                options: ['unordered', 'ordered']
                                            },
                                            blockType: {
                                                options: ['Normal', 'H1', 'H2', 'H3']
                                            },
                                            link: {
                                                showOpenOptionOnHover: false
                                            },
                                            fontSize: {
                                                options: [12, 14, 16, 18, 24, 36]
                                            }
                                        }}
                                        stripPastedStyles={true}
                                        editorStyle={{ minHeight: '250px' }}
                                    />
                                </FormGroup>
                                <FormGroup tag={Col} md='12'>
                                    <h6 className="font-weight-bolder bg-light p-1">
                                        Social Media Links
                                    </h6>
                                </FormGroup>
                                <FormGroup tag={Col} md='4'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="website"
                                        title="Website"
                                        isRequired={false}
                                    />
                                    <Input type="text"
                                        name='website'
                                        id="website"
                                        value={updateProfileForm.values.website}
                                        onBlur={updateProfileForm.handleBlur}
                                        onChange={updateProfileForm.handleChange}
                                        className={classnames({ 'is-invalid': updateProfileForm.touched.website && updateProfileForm.errors.website })}
                                        placeholder="Website URL"
                                        disabled={viewProfileLoading || saveProfileLoading}
                                    />
                                    <div className="validation-err">{updateProfileForm.touched.website && updateProfileForm.errors.website}</div>
                                </FormGroup>
                                <FormGroup tag={Col} md='4'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="facebook"
                                        title="Facebook"
                                        isRequired={false}
                                    />
                                    <Input type="text"
                                        name="facebook"
                                        id="facebook"
                                        value={updateProfileForm.values.facebook}
                                        onBlur={updateProfileForm.handleBlur}
                                        onChange={updateProfileForm.handleChange}
                                        className={classnames({ 'is-invalid': updateProfileForm.touched.facebook && updateProfileForm.errors.facebook })}
                                        placeholder="Facebook URL"
                                        disabled={viewProfileLoading || saveProfileLoading}
                                    />
                                    <div className="validation-err">{updateProfileForm.touched.facebook && updateProfileForm.errors.facebook}</div>
                                </FormGroup>
                                <FormGroup tag={Col} md='4'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="instagram"
                                        title="Instagram"
                                        isRequired={false}
                                    />
                                    <Input type="text"
                                        name="instagram"
                                        id="instagram"
                                        value={updateProfileForm.values.instagram}
                                        onBlur={updateProfileForm.handleBlur}
                                        onChange={updateProfileForm.handleChange}
                                        className={classnames({ 'is-invalid': updateProfileForm.touched.instagram && updateProfileForm.errors.instagram })}
                                        placeholder="Instagram URL"
                                        disabled={viewProfileLoading || saveProfileLoading}
                                    />
                                    <div className="validation-err">{updateProfileForm.touched.instagram && updateProfileForm.errors.instagram}</div>
                                </FormGroup>
                                <FormGroup tag={Col} md='4'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="twitter"
                                        title="X (Twitter)"
                                        isRequired={false}
                                    />
                                    <Input type="text"
                                        name="twitter"
                                        id="twitter"
                                        value={updateProfileForm.values.twitter}
                                        onBlur={updateProfileForm.handleBlur}
                                        onChange={updateProfileForm.handleChange}
                                        className={classnames({ 'is-invalid': updateProfileForm.touched.twitter && updateProfileForm.errors.twitter })}
                                        placeholder="X (Twitter) URL (e.g. https://x.com/username)"
                                        disabled={viewProfileLoading || saveProfileLoading}
                                    />
                                    <div className="validation-err">{updateProfileForm.touched.twitter && updateProfileForm.errors.twitter}</div>
                                </FormGroup>
                                <FormGroup tag={Col} md='4'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="pinterest"
                                        title="Pinterest"
                                        isRequired={false}
                                    />
                                    <Input type="text"
                                        name="pinterest"
                                        id="pinterest"
                                        value={updateProfileForm.values.pinterest}
                                        onBlur={updateProfileForm.handleBlur}
                                        onChange={updateProfileForm.handleChange}
                                        className={classnames({ 'is-invalid': updateProfileForm.touched.pinterest && updateProfileForm.errors.pinterest })}
                                        placeholder="Pinterest URL"
                                        disabled={viewProfileLoading || saveProfileLoading}
                                    />
                                    <div className="validation-err">{updateProfileForm.touched.pinterest && updateProfileForm.errors.pinterest}</div>
                                </FormGroup>
                                <FormGroup tag={Col} md='4'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="linkedin"
                                        title="LinkedIn"
                                        isRequired={false}
                                    />
                                    <Input type="text"
                                        name="linkedin"
                                        id="linkedin"
                                        value={updateProfileForm.values.linkedin}
                                        onBlur={updateProfileForm.handleBlur}
                                        onChange={updateProfileForm.handleChange}
                                        className={classnames({ 'is-invalid': updateProfileForm.touched.linkedin && updateProfileForm.errors.linkedin })}
                                        placeholder="LinkedIn URL"
                                        disabled={viewProfileLoading || saveProfileLoading}
                                    />
                                    <div className="validation-err">{updateProfileForm.touched.linkedin && updateProfileForm.errors.linkedin}</div>
                                </FormGroup>
                                <FormGroup tag={Col} md='4'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="tiktok"
                                        title="TikTok"
                                        isRequired={false}
                                    />
                                    <Input type="text"
                                        name="tiktok"
                                        id="tiktok"
                                        value={updateProfileForm.values.tiktok}
                                        onBlur={updateProfileForm.handleBlur}
                                        onChange={updateProfileForm.handleChange}
                                        className={classnames({ 'is-invalid': updateProfileForm.touched.tiktok && updateProfileForm.errors.tiktok })}
                                        placeholder="TikTok URL"
                                        disabled={viewProfileLoading || saveProfileLoading}
                                    />
                                    <div className="validation-err">{updateProfileForm.touched.tiktok && updateProfileForm.errors.tiktok}</div>
                                </FormGroup>
                                <FormGroup tag={Col} md='12'>
                                    <h6 className="font-weight-bolder bg-light p-1">
                                        Discount Codes & Promotions
                                    </h6>
                                </FormGroup>

                                {/* Brand Shop Website URL */}
                                <FormGroup tag={Col} md='12'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="shopWebsite"
                                        title="Brand Shop Website URL"
                                        isRequired={false}
                                    />
                                    <Input
                                        type="text"
                                        name="shopWebsite"
                                        id="shopWebsite"
                                        value={updateProfileForm.values.shopWebsite}
                                        onBlur={updateProfileForm.handleBlur}
                                        onChange={updateProfileForm.handleChange}
                                        className={classnames({ 'is-invalid': updateProfileForm.touched.shopWebsite && updateProfileForm.errors.shopWebsite })}
                                        placeholder="https://drinkag1.com/shop"
                                        disabled={viewProfileLoading || saveProfileLoading}
                                    />
                                    <div className="validation-err">{updateProfileForm.touched.shopWebsite && updateProfileForm.errors.shopWebsite}</div>
                                </FormGroup>

                                {/* RD Discount Fields */}
                                <FormGroup tag={Col} md='3' sm='6' xs='12'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="discountCode"
                                        title="RD Coupon Code"
                                        isRequired={false}
                                    />
                                    <Input
                                        type="text"
                                        name="discountCode"
                                        id="discountCode"
                                        value={updateProfileForm.values.discountCode}
                                        onBlur={updateProfileForm.handleBlur}
                                        onChange={(e) => {
                                            updateProfileForm.handleChange(e)
                                            recompileAllDiscountDetails(rdDiscountOffer, rdDiscountScope, rdDiscountExpiryDate, rdDiscountNoExpiry, clientDiscountOffer, clientDiscountScope, clientDiscountExpiryDate, clientDiscountNoExpiry, discountCustomNote)
                                        }}
                                        className={classnames({ 'is-invalid': updateProfileForm.touched.discountCode && updateProfileForm.errors.discountCode })}
                                        placeholder="e.g. RDLINK20"
                                        disabled={viewProfileLoading || saveProfileLoading}
                                    />
                                    <div className="validation-err">{updateProfileForm.touched.discountCode && updateProfileForm.errors.discountCode}</div>
                                </FormGroup>

                                <FormGroup tag={Col} md='3' sm='6' xs='12'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="rdDiscountOffer"
                                        title="RD Discount Offer"
                                        isRequired={false}
                                    />
                                    <Input
                                        type="text"
                                        id="rdDiscountOffer"
                                        placeholder="e.g. 20% off, $15 off"
                                        value={rdDiscountOffer}
                                        onChange={(e) => handleRdOfferChange(e.target.value)}
                                        disabled={!updateProfileForm.values.discountCode?.trim() || viewProfileLoading || saveProfileLoading}
                                    />
                                    <div className="d-flex flex-wrap mt-50" style={{ gap: '4px' }}>
                                        {['25% off', '20% off', '15% off', '$15 off', 'Free Shipping'].map((preset) => (
                                            <button
                                                key={`rd-${preset}`}
                                                type="button"
                                                className="btn btn-xs btn-outline-secondary py-25 px-50"
                                                style={{ fontSize: '11px', borderRadius: '4px' }}
                                                onClick={() => handleRdOfferChange(preset)}
                                                disabled={!updateProfileForm.values.discountCode?.trim() || viewProfileLoading || saveProfileLoading}
                                            >
                                                {preset}
                                            </button>
                                        ))}
                                    </div>
                                </FormGroup>

                                <FormGroup tag={Col} md='3' sm='6' xs='12'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="rdDiscountScope"
                                        title="RD Scope / Terms"
                                        isRequired={false}
                                    />
                                    <Input
                                        type="text"
                                        id="rdDiscountScope"
                                        placeholder="e.g. any order, no minimum"
                                        value={rdDiscountScope}
                                        onChange={(e) => handleRdScopeChange(e.target.value)}
                                        disabled={!updateProfileForm.values.discountCode?.trim() || viewProfileLoading || saveProfileLoading}
                                    />
                                    <div className="d-flex flex-wrap mt-50" style={{ gap: '4px' }}>
                                        {['any order', 'no minimum', 'orders over $50', 'first purchase only'].map((preset) => (
                                            <button
                                                key={`rd-scope-${preset}`}
                                                type="button"
                                                className="btn btn-xs btn-outline-secondary py-25 px-50"
                                                style={{ fontSize: '11px', borderRadius: '4px' }}
                                                onClick={() => handleRdScopeChange(preset)}
                                                disabled={!updateProfileForm.values.discountCode?.trim() || viewProfileLoading || saveProfileLoading}
                                            >
                                                {preset}
                                            </button>
                                        ))}
                                    </div>
                                </FormGroup>

                                <FormGroup tag={Col} md='3' sm='6' xs='12'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="rdDiscountExpiryPicker"
                                        title="RD Expiration Date"
                                        isRequired={false}
                                    />
                                    <div className="position-relative">
                                        <Flatpickr
                                            key={`rdExpiryPicker-${rdDiscountNoExpiry ? 'none' : 'active'}`}
                                            id="rdDiscountExpiryPicker"
                                            className={classnames("form-control cursor-pointer bg-white w-100", {
                                                "bg-light text-muted": rdDiscountNoExpiry || !updateProfileForm.values.discountCode?.trim()
                                            })}
                                            placeholder={rdDiscountNoExpiry ? "Ongoing (No expiry)" : "RD end date"}
                                            value={rdDiscountExpiryDate ? (rdDiscountExpiryDate instanceof Date ? rdDiscountExpiryDate : new Date(rdDiscountExpiryDate)) : ''}
                                            disabled={!updateProfileForm.values.discountCode?.trim() || rdDiscountNoExpiry || viewProfileLoading || saveProfileLoading}
                                            options={{
                                                dateFormat: 'M d, Y',
                                                disableMobile: true
                                            }}
                                            onChange={(selectedDates) => {
                                                if (selectedDates && selectedDates.length > 0) {
                                                    handleRdDateChange(selectedDates[0])
                                                }
                                            }}
                                        />
                                        {!rdDiscountNoExpiry && !!rdDiscountExpiryDate && (
                                            <button
                                                type="button"
                                                className="btn btn-xs btn-link text-danger position-absolute"
                                                style={{ right: '8px', top: '50%', transform: 'translateY(-50%)', padding: 0, zIndex: 5 }}
                                                onClick={() => handleRdDateChange(null)}
                                                title="Clear date"
                                                disabled={!updateProfileForm.values.discountCode?.trim() || viewProfileLoading || saveProfileLoading}
                                            >
                                                <X size={14} />
                                            </button>
                                        )}
                                    </div>
                                    <div className="mt-50">
                                        <CustomInput
                                            type="checkbox"
                                            id="rdDiscountNoExpiryCheckbox"
                                            label="No expiration date (Ongoing)"
                                            checked={rdDiscountNoExpiry}
                                            onChange={(e) => handleRdNoExpiryChange(e.target.checked)}
                                            className="font-small-2 cursor-pointer"
                                            disabled={!updateProfileForm.values.discountCode?.trim() || viewProfileLoading || saveProfileLoading}
                                        />
                                    </div>
                                </FormGroup>

                                {/* Client Discount Fields */}
                                <FormGroup tag={Col} md='3' sm='6' xs='12'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="clientDiscountCode"
                                        title="Client Coupon Code"
                                        isRequired={false}
                                    />
                                    <Input
                                        type="text"
                                        name="clientDiscountCode"
                                        id="clientDiscountCode"
                                        value={updateProfileForm.values.clientDiscountCode}
                                        onBlur={updateProfileForm.handleBlur}
                                        onChange={(e) => {
                                            updateProfileForm.handleChange(e)
                                            recompileAllDiscountDetails(rdDiscountOffer, rdDiscountScope, rdDiscountExpiryDate, rdDiscountNoExpiry, clientDiscountOffer, clientDiscountScope, clientDiscountExpiryDate, clientDiscountNoExpiry, discountCustomNote)
                                        }}
                                        className={classnames({ 'is-invalid': updateProfileForm.touched.clientDiscountCode && updateProfileForm.errors.clientDiscountCode })}
                                        placeholder="e.g. CLIENT10"
                                        disabled={viewProfileLoading || saveProfileLoading}
                                    />
                                    <div className="validation-err">{updateProfileForm.touched.clientDiscountCode && updateProfileForm.errors.clientDiscountCode}</div>
                                </FormGroup>

                                <FormGroup tag={Col} md='3' sm='6' xs='12'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="clientDiscountOffer"
                                        title="Client Discount Offer"
                                        isRequired={false}
                                    />
                                    <Input
                                        type="text"
                                        id="clientDiscountOffer"
                                        placeholder="e.g. 10% off, $10 off"
                                        value={clientDiscountOffer}
                                        onChange={(e) => handleClientOfferChange(e.target.value)}
                                        disabled={!updateProfileForm.values.clientDiscountCode?.trim() || viewProfileLoading || saveProfileLoading}
                                    />
                                    <div className="d-flex flex-wrap mt-50" style={{ gap: '4px' }}>
                                        {['15% off', '10% off', '5% off', '$10 off', 'Free Shipping'].map((preset) => (
                                            <button
                                                key={`client-${preset}`}
                                                type="button"
                                                className="btn btn-xs btn-outline-secondary py-25 px-50"
                                                style={{ fontSize: '11px', borderRadius: '4px' }}
                                                onClick={() => handleClientOfferChange(preset)}
                                                disabled={!updateProfileForm.values.clientDiscountCode?.trim() || viewProfileLoading || saveProfileLoading}
                                            >
                                                {preset}
                                            </button>
                                        ))}
                                    </div>
                                </FormGroup>

                                <FormGroup tag={Col} md='3' sm='6' xs='12'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="clientDiscountScope"
                                        title="Client Scope / Terms"
                                        isRequired={false}
                                    />
                                    <Input
                                        type="text"
                                        id="clientDiscountScope"
                                        placeholder="e.g. first purchase, any order"
                                        value={clientDiscountScope}
                                        onChange={(e) => handleClientScopeChange(e.target.value)}
                                        disabled={!updateProfileForm.values.clientDiscountCode?.trim() || viewProfileLoading || saveProfileLoading}
                                    />
                                    <div className="d-flex flex-wrap mt-50" style={{ gap: '4px' }}>
                                        {['first purchase only', 'any order', 'no minimum', 'orders over $50'].map((preset) => (
                                            <button
                                                key={`client-scope-${preset}`}
                                                type="button"
                                                className="btn btn-xs btn-outline-secondary py-25 px-50"
                                                style={{ fontSize: '11px', borderRadius: '4px' }}
                                                onClick={() => handleClientScopeChange(preset)}
                                                disabled={!updateProfileForm.values.clientDiscountCode?.trim() || viewProfileLoading || saveProfileLoading}
                                            >
                                                {preset}
                                            </button>
                                        ))}
                                    </div>
                                </FormGroup>

                                <FormGroup tag={Col} md='3' sm='6' xs='12'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="clientDiscountExpiryPicker"
                                        title="Client Expiration Date"
                                        isRequired={false}
                                    />
                                    <div className="position-relative">
                                        <Flatpickr
                                            key={`clientExpiryPicker-${clientDiscountNoExpiry ? 'none' : 'active'}`}
                                            id="clientDiscountExpiryPicker"
                                            className={classnames("form-control cursor-pointer bg-white w-100", {
                                                "bg-light text-muted": clientDiscountNoExpiry || !updateProfileForm.values.clientDiscountCode?.trim()
                                            })}
                                            placeholder={clientDiscountNoExpiry ? "Ongoing (No expiry)" : "Client end date"}
                                            value={clientDiscountExpiryDate ? (clientDiscountExpiryDate instanceof Date ? clientDiscountExpiryDate : new Date(clientDiscountExpiryDate)) : ''}
                                            disabled={!updateProfileForm.values.clientDiscountCode?.trim() || clientDiscountNoExpiry || viewProfileLoading || saveProfileLoading}
                                            options={{
                                                dateFormat: 'M d, Y',
                                                disableMobile: true
                                            }}
                                            onChange={(selectedDates) => {
                                                if (selectedDates && selectedDates.length > 0) {
                                                    handleClientDateChange(selectedDates[0])
                                                }
                                            }}
                                        />
                                        {!clientDiscountNoExpiry && !!clientDiscountExpiryDate && (
                                            <button
                                                type="button"
                                                className="btn btn-xs btn-link text-danger position-absolute"
                                                style={{ right: '8px', top: '50%', transform: 'translateY(-50%)', padding: 0, zIndex: 5 }}
                                                onClick={() => handleClientDateChange(null)}
                                                title="Clear date"
                                                disabled={!updateProfileForm.values.clientDiscountCode?.trim() || viewProfileLoading || saveProfileLoading}
                                            >
                                                <X size={14} />
                                            </button>
                                        )}
                                    </div>
                                    <div className="mt-50">
                                        <CustomInput
                                            type="checkbox"
                                            id="clientDiscountNoExpiryCheckbox"
                                            label="No expiration date (Ongoing)"
                                            checked={clientDiscountNoExpiry}
                                            onChange={(e) => handleClientNoExpiryChange(e.target.checked)}
                                            className="font-small-2 cursor-pointer"
                                            disabled={!updateProfileForm.values.clientDiscountCode?.trim() || viewProfileLoading || saveProfileLoading}
                                        />
                                    </div>
                                </FormGroup>

                                {/* Additional Notes & Summary */}
                                <FormGroup tag={Col} lg='6' md='12' sm='12' xs='12'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="discountCustomNote"
                                        title="Additional Terms / Notes (Optional)"
                                        isRequired={false}
                                    />
                                    <Input
                                        type="text"
                                        id="discountCustomNote"
                                        placeholder="e.g. limit 1 per customer · cannot be combined with other offers"
                                        value={discountCustomNote}
                                        onChange={(e) => handleNoteChange(e.target.value)}
                                        disabled={viewProfileLoading || saveProfileLoading}
                                    />
                                </FormGroup>

                                <FormGroup tag={Col} lg='6' md='12' sm='12' xs='12'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="discountDetails"
                                        title="Discount Terms Summary (Saved to Profile)"
                                        isRequired={false}
                                    />
                                    <Input
                                        type="text"
                                        name="discountDetails"
                                        id="discountDetails"
                                        value={updateProfileForm.values.discountDetails}
                                        onBlur={(e) => {
                                            updateProfileForm.handleBlur(e)
                                            if (e.target.value) {
                                                const parsed = parseDiscountDetails(e.target.value)
                                                setRdDiscountOffer(parsed.rd?.offer || '')
                                                setRdDiscountScope(parsed.rd?.scope || '')
                                                setRdDiscountExpiryDate(parsed.rd?.expiryDate || null)
                                                setRdDiscountNoExpiry(parsed.rd?.noExpiry || false)

                                                setClientDiscountOffer(parsed.client?.offer || '')
                                                setClientDiscountScope(parsed.client?.scope || '')
                                                setClientDiscountExpiryDate(parsed.client?.expiryDate || null)
                                                setClientDiscountNoExpiry(parsed.client?.noExpiry || false)

                                                setDiscountCustomNote(parsed.customNote || '')
                                            }
                                        }}
                                        onChange={updateProfileForm.handleChange}
                                        className={classnames({ 'is-invalid': updateProfileForm.touched.discountDetails && updateProfileForm.errors.discountDetails })}
                                        placeholder="e.g. RD: 20% off · Valid through Dec 31, 2026 | Client: 10% off · Ongoing offer"
                                        disabled={viewProfileLoading || saveProfileLoading}
                                    />
                                    <div className="validation-err">{updateProfileForm.touched.discountDetails && updateProfileForm.errors.discountDetails}</div>
                                    {Boolean(updateProfileForm.values.discountDetails) && (
                                        <small className="text-muted font-small-1 mt-25 d-block">
                                            <strong>Preview on Profile:</strong> "{updateProfileForm.values.discountDetails}"
                                        </small>
                                    )}
                                </FormGroup>
                                <FormGroup tag={Col} md='12'>
                                    <h6 className="font-weight-bolder bg-light p-1">
                                        Select Product and Company Characteristics
                                    </h6>
                                </FormGroup>
                                <FormGroup tag={Col} md="4">
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="companyValues"
                                        title="Company Values"
                                        isRequired={false}
                                    />
                                    <Select isClearable={false}
                                        theme={selectThemeColors}
                                        closeMenuOnSelect={false}
                                        components={animatedComponents}
                                        isMulti={true}
                                        options={brandCompanySelectValues?.values}
                                        value={updateProfileForm.values.companyValues || []}
                                        className='react-select'
                                        classNamePrefix='select'
                                        onChange={(e) => updateProfileForm.setFieldValue('companyValues', e)}
                                        id="companyValues"
                                        isDisabled={viewProfileLoading || saveProfileLoading}
                                    />
                                </FormGroup>
                                <FormGroup tag={Col} md="4">
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="special_diet"
                                        title="Special Diet"
                                        isRequired={false}
                                    />
                                    <Select isClearable={false}
                                        theme={selectThemeColors}
                                        closeMenuOnSelect={false}
                                        components={animatedComponents}
                                        isMulti
                                        options={brandCompanySelectValues?.special_diet}
                                        value={updateProfileForm.values.specialDiet || []}
                                        className='react-select'
                                        classNamePrefix='select'
                                        onChange={(e) => updateProfileForm.setFieldValue('specialDiet', e)}
                                        id="specialDiet"
                                        isDisabled={viewProfileLoading || saveProfileLoading}
                                    />
                                </FormGroup>
                                <FormGroup tag={Col} md="4">
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="foodCategory"
                                        title="Food Category"
                                        isRequired={false}
                                    />
                                    <Select isClearable={false}
                                        theme={selectThemeColors}
                                        closeMenuOnSelect={false}
                                        components={animatedComponents}
                                        isMulti
                                        options={brandCompanySelectValues?.category}
                                        value={updateProfileForm.values.foodCategory || []}
                                        className='react-select'
                                        classNamePrefix='select'
                                        onChange={(e) => updateProfileForm.setFieldValue('foodCategory', e)}
                                        id="foodCategory"
                                        isDisabled={viewProfileLoading || saveProfileLoading}
                                    />
                                </FormGroup>
                                <FormGroup tag={Col} md='12'>
                                    <h6 className="font-weight-bolder bg-light p-1">
                                        <span>What do you hope to get out of using Link?</span>
                                        <span className="is-invalid"> *</span>
                                    </h6>
                                </FormGroup>
                                <FormGroup tag={Col} md='12'>
                                    <Input type="textarea"
                                        name="goals"
                                        id="goals"
                                        rows='10'
                                        value={updateProfileForm.values.goals}
                                        onBlur={updateProfileForm.handleBlur}
                                        onChange={updateProfileForm.handleChange}
                                        className={classnames({ 'is-invalid': updateProfileForm.touched.goals && updateProfileForm.errors.goals })}
                                        placeholder="Your answer here..."
                                        disabled={viewProfileLoading || saveProfileLoading}
                                    />
                                    <div className="validation-err">{updateProfileForm.touched.goals && updateProfileForm.errors.goals}</div>
                                </FormGroup>
                                <FormGroup tag={Col} md='12'>
                                    <h6 className="font-weight-bolder bg-light p-1">
                                        Tell us more about the types of RDs you are hoping to connect with?
                                        This will help us make custom recommendations
                                    </h6>
                                </FormGroup>
                                <FormGroup tag={Col} md="4">
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="personalAttributes"
                                        title="Personal Attributes"
                                        isRequired={false}
                                    />
                                    <Select isClearable={false}
                                        theme={selectThemeColors}
                                        closeMenuOnSelect={false}
                                        components={animatedComponents}
                                        options={brandGoalsSelectValues?.personal_attributes}
                                        value={updateProfileForm.values.personalAttributes || []}
                                        isMulti={true}
                                        className='react-select'
                                        classNamePrefix='select'
                                        placeholder="Select Attributes"
                                        onChange={(e) => updateProfileForm.setFieldValue('personalAttributes', e)}
                                        id="personalAttributes"
                                        isDisabled={viewProfileLoading || saveProfileLoading}
                                    />
                                </FormGroup>
                                <FormGroup tag={Col} md="4">
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="industry"
                                        title="Industry"
                                        isRequired={false}
                                    />
                                    <Select isClearable={false}
                                        theme={selectThemeColors}
                                        closeMenuOnSelect={false}
                                        options={brandGoalsSelectValues?.industry}
                                        components={animatedComponents}
                                        value={updateProfileForm.values.industry || []}
                                        isMulti={true}
                                        className='react-select'
                                        classNamePrefix='select'
                                        placeholder="Select Industry"
                                        onChange={(e) => updateProfileForm.setFieldValue('industry', e)}
                                        id="industry"
                                        isDisabled={viewProfileLoading || saveProfileLoading}
                                    />
                                </FormGroup>
                                <FormGroup tag={Col} md="4">
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="speciality"
                                        title="Speciality"
                                        isRequired={false}
                                    />
                                    <Select isClearable={false}
                                        theme={selectThemeColors}
                                        closeMenuOnSelect={false}
                                        components={animatedComponents}
                                        options={brandGoalsSelectValues?.speciality}
                                        value={updateProfileForm.values.speciality || []}
                                        isMulti={true}
                                        className='react-select'
                                        classNamePrefix='select'
                                        placeholder="Select Speciality"
                                        onChange={(e) => updateProfileForm.setFieldValue('speciality', e)}
                                        id="speciality"
                                        isDisabled={viewProfileLoading || saveProfileLoading}
                                    />
                                </FormGroup>
                                <FormGroup tag={Col} md="6">
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="country"
                                        title="Country"
                                        isRequired={false}
                                        msg='If you wish to change locations, start from the country'
                                    />
                                    <Select isClearable={true}
                                        theme={selectThemeColors}
                                        options={countries}
                                        value={updateProfileForm.values.country}
                                        className='react-select'
                                        classNamePrefix='select'
                                        onChange={(e) => {
                                            updateProfileForm.setFieldValue('country', e)
                                            updateProfileForm.setFieldValue('region', null)
                                            updateProfileForm.setFieldValue('state', [])
                                            updateProfileForm.setFieldValue('city', [])
                                            getStatesById(e, true)
                                        }}
                                        id="country"
                                        isDisabled={viewProfileLoading || saveProfileLoading}
                                    />
                                </FormGroup>
                                
                                {/* <FormGroup tag={Col} md="6">
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="region"
                                        title="Region"
                                        isRequired={false}
                                    />
                                    <div className="overlay-select-parent">
                                        <Select isClearable={true}
                                            theme={selectThemeColors}
                                            options={regions ?? []}
                                            value={updateProfileForm.values.region}
                                            className='react-select'
                                            classNamePrefix='select'
                                            onChange={(e) => {
                                                updateProfileForm.setFieldValue('region', e)
                                                updateProfileForm.setFieldValue('state', [])
                                                updateProfileForm.setFieldValue('city', [])
                                                getStatesById(e)
                                            }}
                                            id='regions'
                                            isDisabled={viewProfileLoading || saveProfileLoading}
                                        />
                                    </div>
                                </FormGroup> */}
                                <FormGroup tag={Col} md="6">
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="state"
                                        title="States"
                                        isRequired={false}
                                    />
                                    <div className="overlay-select-parent">
                                        <Select isClearable={false}
                                            isMulti
                                            closeMenuOnSelect={false}
                                            theme={selectThemeColors}
                                            options={states ?? []}
                                            value={updateProfileForm.values.state || []}
                                            className='react-select'
                                            classNamePrefix='select'
                                            onChange={(e) => {
                                                updateProfileForm.setFieldValue('state', e)
                                                updateProfileForm.setFieldValue('city', [])
                                                getCitiesById(e)
                                            }}
                                            id="states"
                                            isDisabled={viewProfileLoading || saveProfileLoading}
                                        />
                                    </div>
                                </FormGroup>
                                <FormGroup tag={Col} md="6">
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="city"
                                        title="Cities"
                                        isRequired={false}
                                    />
                                    <div className="overlay-select-parent">
                                        <Select isClearable={false}
                                            isMulti
                                            closeMenuOnSelect={false}
                                            theme={selectThemeColors}
                                            options={cities ?? []}
                                            value={updateProfileForm.values.city || []}
                                            className='react-select'
                                            classNamePrefix='select'
                                            onChange={(e) => updateProfileForm.setFieldValue('city', e)}
                                            id="cities"
                                            isDisabled={viewProfileLoading || saveProfileLoading}
                                        />
                                    </div>
                                </FormGroup>
                                <FormGroup tag={Col} md='12'>
                                    <hr />
                                </FormGroup>
                                <FormGroup tag={Col} md='6'>
                                    <CustomLabel
                                        formik={updateProfileForm}
                                        id="hearAboutUs"
                                        title="How did you hear about The RD Link?"
                                        isRequired={false}
                                    />
                                    <Select isClearable={false}
                                        closeMenuOnSelect={true}
                                        theme={selectThemeColors}
                                        options={hearAboutOptions?.data}
                                        value={updateProfileForm.values.hearAboutUs}
                                        className='react-select'
                                        classNamePrefix='select'
                                        onChange={(e) => {
                                            updateProfileForm.setFieldValue('hearAboutUs', e)
                                            updateProfileForm.setFieldValue('hereAboutOtherInput', '')
                                        }}
                                        id="hearAboutUs"
                                        isDisabled={viewProfileLoading || saveProfileLoading}
                                    />
                                </FormGroup>
                                <FormGroup tag={Col} md='6'>
                                    {updateProfileForm.values?.hearAboutUs?.id === 'Other' && (
                                        <>
                                            <CustomLabel
                                                formik={updateProfileForm}
                                                id="hereAboutOtherInput"
                                                title="Where did you hear about us?"
                                                isRequired={false}
                                            />
                                            <Input type="text"
                                                name="hereAboutOtherInput"
                                                id="hereAboutOtherInput"
                                                value={updateProfileForm.values.hereAboutOtherInput}
                                                onBlur={updateProfileForm.handleBlur}
                                                onChange={updateProfileForm.handleChange}
                                                placeholder="Your answer..."
                                                disabled={viewProfileLoading || saveProfileLoading}
                                            />
                                        </>
                                    )}
                                </FormGroup>
                                <FormGroup tag={Col} md='12'>
                                    <h6 className="font-weight-bolder bg-light p-1">
                                        Upload Product Image, PDF or Video
                                    </h6>
                                </FormGroup>
                                <FormGroup tag={Col} md="12">
                                    <Button.Ripple color='primary' type="button" disabled={viewProfileLoading || saveProfileLoading} onClick={() => setShowUploader(true)}>
                                        <File size='16' /> Upload File
                                    </Button.Ripple>
                                    {attachments?.length > 0 && (
                                        <>
                                            <Table className='mt-1 mb-1 table-bordered' responsive>
                                                <thead>
                                                    <tr>
                                                        <th width={1}>Sr.</th>
                                                        <th>Uploads</th>
                                                        <th style={{ minWidth: '220px' }}>Resource Category</th>
                                                        <th width={100}>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {attachments.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.title || item.original_name || 'Uploaded File'}</td>
                                                            <td>
                                                                <CustomInput
                                                                    type="select"
                                                                    id={`res-cat-${index}`}
                                                                    name={`res-cat-${index}`}
                                                                    value={item.resource_category || 'education'}
                                                                    onChange={(e) => {
                                                                        const selectedVal = e.target.value
                                                                        setAttachments(prev => prev.map((att, i) => (
                                                                            i === index ? { ...att, resource_category: selectedVal } : att
                                                                        )))
                                                                    }}
                                                                >
                                                                    <option value="education">Brand Education (Learn)</option>
                                                                    <option value="practice">Practice Resources (Use in Practice)</option>
                                                                </CustomInput>
                                                            </td>
                                                            <td>
                                                                <Button.Ripple color='danger' type="button" size='sm'
                                                                    onClick={() => deleteUploads(index)} disabled={viewProfileLoading || saveProfileLoading}>
                                                                    <Trash size='14' /> Delete
                                                                </Button.Ripple>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </>
                                    )}
                                </FormGroup>
                                {profileMedia?.length > 0 && (
                                    <>
                                        <FormGroup tag={Col} md='12'>
                                            <h6 className="font-weight-bolder bg-light p-1">
                                                Attachments
                                            </h6>
                                        </FormGroup>
                                        <FormGroup tag={Col} sm="12" className="d-flex flex-wrap">
                                            {profileMedia?.map((media, i) => {
                                                const type = media.image_type?.toLowerCase()
                                                return (
                                                    <Fragment key={i}>
                                                        {(type === 'png' || type === 'jpg' || type === 'jpeg') && (
                                                            <div className='media-img media-file'>
                                                                <div className="remove-icon">
                                                                    <button type="button" className='btn btn-link p-0 text-danger' onClick={() => handleRemoveMedia(media)}>
                                                                        <X size={16} />
                                                                    </button>
                                                                </div>
                                                                <div className="download-icon">
                                                                    <button type="button" className='btn btn-link p-0'
                                                                        onClick={() => setImageViewer({ show: true, src: media.image_url })}>
                                                                        <Eye size={16} />
                                                                    </button>
                                                                </div>
                                                                <div className="name-wrap">
                                                                    <img className='rounded img-fit-contain' src={media?.image_url} alt={media.product_image}
                                                                        style={{ height: '100px', width: '100px' }} />
                                                                    <p className="text-truncate mt-1">
                                                                        <strong>{media.product_image}</strong>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {(type === 'pdf') && (
                                                            <div className='media-img media-file'>
                                                                <div className="remove-icon">
                                                                    <button type="button" className='btn btn-link p-0 text-danger' onClick={() => handleRemoveMedia(media)}>
                                                                        <X size={16} />
                                                                    </button>
                                                                </div>
                                                                <div className="download-icon">
                                                                    <button type="button" className='btn btn-link p-0'
                                                                        onClick={() => setPdfViewer({ show: true, url: media.image_url, filename: media.product_image })}>
                                                                        <Eye size={16} />
                                                                    </button>
                                                                </div>
                                                                <div className="name-wrap">
                                                                    <img className='rounded img-fit-contain png-icon-img' src={PDF} alt={media.product_image} />
                                                                    <p className="text-truncate mt-1">
                                                                        <strong>{media.product_image}</strong>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {(type === 'mp4') && (
                                                            <div className='media-img media-file'>
                                                                <div className="remove-icon">
                                                                    <button type="button" className='btn btn-link p-0 text-danger' onClick={() => handleRemoveMedia(media)}>
                                                                        <X size={16} />
                                                                    </button>
                                                                </div>
                                                                <div className="download-icon">
                                                                    <button type="button" className='btn btn-link p-0'
                                                                        onClick={() => setVideoPlayer({ show: true, url: media.image_url, filename: media.product_image })}>
                                                                        <Eye size={16} />
                                                                    </button>
                                                                </div>
                                                                <div className="name-wrap">
                                                                    <Video className="text-primary text-center" size={90} />
                                                                    <p className="text-truncate mt-1">
                                                                        <strong>{media.product_image}</strong>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Fragment>)
                                            })}
                                        </FormGroup>
                                    </>
                                )}
                                <FormGroup tag={Col} md='12'>
                                    <hr />
                                </FormGroup>
                                <FormGroup tag={Col} sm="12" className="d-flex align-items-center justify-content-end">
                                    <div>
                                        <Button.Ripple color='success' type="submit" disabled={viewProfileLoading || saveProfileLoading}>
                                            {saveProfileLoading ? (
                                                <span><Spinner style={{ width: '16px', height: '16px' }} /> Updating Profile...</span>
                                            ) : (
                                                <span>Update Profile <ArrowRight size="18" /></span>
                                            )}
                                        </Button.Ripple>
                                    </div>
                                </FormGroup>
                            </Row>
                        </Form>
                    )}
                </CardBody>
            </Card>
            <Uploader
                show={showUploader}
                hide={() => setShowUploader(false)}
                onSuccess={(data) => onSuccessUploads(data)}
                onError={(error) => onErrorUploads(error)}
            />
            <ImageViewer
                show={imageViewer.show}
                hide={() => setImageViewer({ show: false, src: '' })}
                images={[{ src: imageViewer.src }]}
            />
            <PdfViewer show={pdfViewer.show}
                url={pdfViewer.url}
                filename={pdfViewer.filename}
                hide={() => setPdfViewer({ show: false, url: '', filename: '' })}
            />
            <VideoPlayer show={videoPlayer.show}
                url={videoPlayer.url}
                filename={videoPlayer.filename}
                hide={() => setVideoPlayer({ show: false, url: '', filename: '' })}
            />
        </Fragment>
    )
}

export default EditBrandProfile